
export function StatCard({ icon: Icon, iconBgColor, value, maxValue, label, percentage, trend = "", svg = "", }) {
  return (
    <div className="bg-white rounded-[10px]  py-5 px-[15px] hover:shadow-md transition-shadow border border-[#E1E4EA] w-full h-full">
      <div className="flex flex-col justify-between gap-3 w-full h-full">
        <div className="space-y-3">
          <div className={`max-w-max p-[5px] bg-[${iconBgColor}] rounded-[5px] flex items-center justify-center`} style={{ background: iconBgColor }}>
            {Icon ? (<Icon className={`w-6 h-6 !text-[#fff]`} />) : svg ? (svg) : null}
          </div>

          <div className="flex flex-col gap-[10px]">
            <div className="flex items-baseline space-x-1">
              <span className="text-[26px] font-semibold text-[#0E121B]">{value}</span>
              <span className="text-[18px] text-[#999] font-semibold">/{maxValue}</span>
            </div>
            <p className="text-xs text-[#999] font-medium   leading-tight">{label}</p>
          </div>
        </div>

        <div className="space-y-3">
          <div className="bg-[#E1E4EA]  h-[1px]"></div>

          <div className="flex items-center space-x-1  ">
            {trend === "up" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.46362 13.3333V2.66666M8.46362 2.66666L4.46362 6.66666M8.46362 2.66666L12.4636 6.66666"
                  stroke="#84CC16"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.46368 2.66665L8.46368 13.3333M8.46368 13.3333L12.4637 9.33331M8.46368 13.3333L4.46368 9.33331"
                  stroke="#FF4040"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <span className={`text-xs font-medium text-[#0E121B] `}>
              {percentage}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function StatCardNew({ icon: Icon, iconBgColor, value, maxValue, label, percentage, trend = "", svg = "", heading, HeadingIcon, type, ...props}) {
  return (
    <div className="bg-white rounded-[10px]  py-5 px-[15px] hover:shadow-md transition-shadow border border-[#E1E4EA] w-full h-full" {...props}>
      <div className="flex flex-col justify-between gap-3 w-full h-full">
        <div className="flex flex-col gap-[20px]">

          {type == "main" ?
            <h3 className="text-[14px] font-medium text-[#0E121B] flex items-center gap-[8px]">
                <div className={`max-w-max p-[5px] bg-[${iconBgColor}] rounded-[5px] flex items-center justify-center`} style={{ background: iconBgColor }}>
                    {Icon ? (<Icon className={`w-6 h-6 !text-[#fff]`} />) : svg ? (svg) : null}
                </div>
                {heading}
            </h3>
            :
            <h3 className="text-[14px] font-medium text-[#0E121B] flex items-center gap-[8px]">
                {HeadingIcon ? <HeadingIcon /> : null}
                {heading}
            </h3>
          }
            

          <div className="flex flex-col gap-[10px]">
            {type == "main" ?
                <div className="flex items-center justify-between">
                    <span className="text-[#0E121B] text-[26px] font-semibold">{value}</span>
                </div>
                :
                <div className="flex items-center justify-between">
                    {Icon ? (<Icon className={`w-6 h-6 !text-[#fff]`} />) : svg ? (svg) : null}
                    <span className="text-[#0E121B] text-[26px] font-semibold">{value}</span>
                </div>
            }
            {/* <p className="text-xs text-[#999] font-medium   leading-tight">{label}</p> */}
          </div>
        </div>

        <div className="space-y-3">
          <div className="bg-[#E1E4EA]  h-[1px]"></div>

          <div className="flex items-center space-x-1  ">
            {trend === "up" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.46362 13.3333V2.66666M8.46362 2.66666L4.46362 6.66666M8.46362 2.66666L12.4636 6.66666"
                  stroke="#84CC16"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8.46368 2.66665L8.46368 13.3333M8.46368 13.3333L12.4637 9.33331M8.46368 13.3333L4.46368 9.33331"
                  stroke="#FF4040"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <span className={`text-xs font-medium text-[#0E121B] `}>
              {percentage}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}